import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';

const removeDrawerOrganizersInScene = ({ coreApi }: BehaviorParameters) => {
  const drawers = coreApi.entities.getByComponent(ComponentIds.DRAWER_COMPONENT_ID);
  const drawerOrganizers = drawers.flatMap(drawer =>
    coreApi.entities.getDescendantsWithOneOfProductTypes(drawer, [
      ProductType.BESTA_DRAWER_ORGANIZER,
      ProductType.BESTA_SHELF_AND_DRAWER_ORGANIZER
    ])
  );
  coreApi.entities.deleteMultiple(drawerOrganizers);
};

export default removeDrawerOrganizersInScene;
